import { styled } from "styled-components";
import TooltipProvider from "./TooltipProvider";

export type Variant = "primary" | "secondary" | "light" | "dark";

export interface IconButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  variant?: Variant;
  "data-testid"?: string;
  // Names the button for assistive tech; the icon class carries no text.
  "aria-label"?: string;
  tooltip?: string;
  size?: "sm" | "lg";
}

const StyledButton = styled.button<{
  $size: "sm" | "lg";
  $variant: Variant;
}>`
  background: none;
  border: none;
  color: ${({ $variant }) => {
    if ($variant === "dark") {
      return "var(--aa-light-black)";
    } else if ($variant === "secondary") {
      return "var(--aa-text-muted)";
    } else if ($variant === "light") {
      return "var(--aa-beige)";
    } else {
      // $variant === "primary"
      return "rgb(var(--bs-link-color-rgb))";
    }
  }};
  font-size: ${({ $size }) => ($size === "sm" ? "0.875rem" : "1.25rem")};
  line-height: ${({ $size }) => ($size === "sm" ? "0.875" : "1.25")};
`;

const IconButton = ({
  className,
  disabled,
  onClick,
  variant = "secondary",
  tooltip,
  size = "sm",
  "data-testid": testId,
  "aria-label": ariaLabel,
}: IconButtonProps) => {
  const button = (
    <StyledButton
      disabled={disabled}
      $size={size}
      $variant={variant}
      onClick={onClick}
      className={className}
      data-testid={testId}
      aria-label={ariaLabel}
    />
  );

  return tooltip ? (
    <TooltipProvider tooltip={tooltip}>{button}</TooltipProvider>
  ) : (
    button
  );
};

export default IconButton;
